import axios from 'axios'
import Vue from 'vue'

function resolveApiOrigin() {
  return 'https://stagingapi.replyengine.io/'
}

const apiOrigin = resolveApiOrigin()
const normalizedOrigin = apiOrigin.endsWith('/') ? apiOrigin : `${apiOrigin}/`

axios.defaults.baseURL = normalizedOrigin + 'api/v1'
axios.defaults.headers.common['Authorization'] =
  'Bearer ' + localStorage.getItem('access_token')
axios.interceptors.request.use((config) => {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    config.headers['X-App-Host'] = window.location.hostname
  }
  const originalUserId = localStorage.getItem('original_user_id');
  if (originalUserId) {
    config.headers['X-Original-User'] = originalUserId;
  }
  return config; 
}, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use(
  (response) => {
    // Show success message
    if (response.data && response.data.message && response.data.success) {
      Vue.$toast.open({
        message: response.data.message,
        type: 'success',
        duration: 5000,
      })
    }
    return response
  },
  (error) => {
    console.log(error);
    if (error.response.status === 422) {
      // Show error message
      const { errors } = error.response.data
      const keys = Object.keys(errors);
      const message = errors[keys[0]] ? errors[keys[0]][0] : ''
      if (message) {
        Vue.$toast.open({
          message: message,
          type: 'error',
          duration: 5000,
        })
      }
    } else {
      if (error.response && error.response.status === 406) {

      } else if (error.response && error.response.data && error.response.data.message) {
        // Show error message
        Vue.$toast.open({
          message: error.response.data.message,
          type: 'error',
          duration: 5000,
        })
      }
    }

    // Catch 401 request
    if (error.response.status === 401) {
    } else {
      return Promise.reject(error)
    }
  }
)
